import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, FilePlusIcon } from 'lucide-react';
import { RequestComposer } from '../components/demandes/RequestComposer';
import { PublicReportsMap } from '../components/demandes/PublicReportsMap';
import { RequestList } from '../components/demandes/RequestList';
export function MesDemandes() {
  return <main className="bg-white" data-id="element-2194" data-mp="2ybq3ps601zwx">
      <div className="mx-auto max-w-[1180px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2195" data-mp="3c4obyf3jjmhw">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2196" data-mp="383mbxw1sv6ev">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2197" data-mp="3m3dixctwfmjd">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2198" data-mp="3h40y0xml8pjf" />
          <span aria-current="page" data-id="element-2199" data-mp="1rpcnl1xk5ho1">Mes demandes</span>
        </nav>

        <div className="mt-4 flex flex-wrap items-start justify-between gap-4" data-id="element-2200" data-mp="1rpmf4ty93wvu">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2201" data-mp="1mrkui4l6fpi9">Mes demandes</h1>
          <button type="button" className="inline-flex shrink-0 items-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2202" data-mp="2ra1rx3gjjtbh">
            <FilePlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-2203" data-mp="39ygg7izh4t8l" />
            Créer une demande manuellement
          </button>
        </div>

        <div className="mt-8 max-w-[880px]" data-id="element-2204" data-mp="3jx5y3brdedou">
          <RequestComposer data-id="element-2205" data-mp="3jyh2ndsn3ph0" />
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-10" data-id="element-2206" data-mp="3jvbec0ru4rmc">
          <PublicReportsMap data-id="element-2207" data-mp="3nwerugmeubke" />
          <RequestList data-id="element-2208" data-mp="1pjmsrfr3lqsz" />
        </div>
      </div>
    </main>;
}